<template>
  <v-app>
    <v-content>
      <router-view :category="category" @info="details" />
    </v-content>
    
    <update-wrapper></update-wrapper>
    
  </v-app>
</template>

<script>
import UpdateWrapper from './components/Update.vue'

export default {
  components: {
    UpdateWrapper
  },
  data () {
    return {
      category: null,
      dialog: false,
      app: null
    }
  },
  localStorage: {
    user: {
      type: Object,
      default: {
        authenticated: false,
        name: '',
        email: '',
        picture: '',
        token: ''
      }
    },
    synchronized: {
      type: Number,
      default: 0
    },
    iosTryInstall: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    details (app) {
      console.log('details')
      this.$refs.info.show(app)
    }
  },
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue